import * as XLSX from "xlsx/xlsx.mjs";
import { formatPayeeAddress } from "./paymentPayee";
import { getStatusDates, pickStatusDate } from "./paymentDates";

function safe(fn) {
    try {
        return fn();
    } catch {
        return "";
    }
}

/**
 * Builds the aoa (array of arrays) for a payment report xlsx export.
 *
 * @param {object} data the raw PAYMENT_REPORTS result
 * @param {object} options
 * @param {string} options.idLabel header for the payment-identifier column
 * @param {(patient: object) => any} options.getIdCell value for that column
 * @param {any[]} [options.trailingCells] extra cells appended to each data row
 */
export function buildPaymentRows(data, { idLabel, getIdCell, trailingCells = [] }) {
    const rows = [["Product", "Patient Name", "DOB", "Member Number", "DOS", "Payee Info", "Amount", idLabel, "Status Date", "Status"]];

    data.providerreports.forEach((patient) => {
        const claim_data = safe(() => patient.claim_data);
        const date_of_service = safe(() => patient.date_of_service);
        const dates = getStatusDates(claim_data, date_of_service);

        rows.push([
            safe(() => patient.program),
            safe(() => patient.last_name) + ", " + safe(() => patient.first_name),
            safe(() => patient.date_of_birth),
            safe(() => patient.member_id),
            date_of_service,
            formatPayeeAddress(claim_data),
            safe(() => "$" + parseFloat(patient.claim_data.program_benefit).toFixed(2)),
            getIdCell(patient),
            pickStatusDate(dates),
            dates.paid_date != null ? "Paid" : safe(() => patient.claim_status),
            ...trailingCells,
        ]);
    });

    return rows;
}

/**
 * Excel rejects sheet names longer than 31 chars or containing []:*?/\, and
 * book_append_sheet throws on both - which silently aborts the download.
 */
function toSheetName(name) {
    return String(name).replace(/[[\]:*?/\\]/g, " ").trim().slice(0, 31);
}

/** Writes the workbook as "<filePrefix>MM-DD-YYYY.xlsx". */
export function downloadPaymentXlsx(rows, sheetName, filePrefix) {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const formattedToday = mm + "-" + dd + "-" + yyyy;

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(rows, { origin: "A1", skipHeader: false });
    XLSX.utils.book_append_sheet(wb, ws, toSheetName(sheetName));
    XLSX.writeFile(wb, filePrefix + formattedToday + ".xlsx");
}


